import React, { FC } from "react";

import { useHeaderMenu } from "../../../../../hooks/use-header-menu";
import { LoginButton } from "../../../common/login-button";
import { SignupButton } from "../../../common/signup-button";
import { HeaderMenuItemDetailTitle } from "../../header-menu-item-detail-title";

export interface PersonalAreaUnauthenticatedProps {}

export const PersonalAreaUnauthenticated: FC<PersonalAreaUnauthenticatedProps> = ({}) => {
  const { labels } = useHeaderMenu();

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <HeaderMenuItemDetailTitle
          titleClassName="text-primary"
          title={labels["header-menu-personal-area-login-title"]}
        />
        <p className="font-light">{labels["header-menu-personal-area-login-body"]}</p>
        <LoginButton />
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="text-2xl text-primary">
          {labels["header-menu-personal-area-signup-title"]}
        </h3>
        <p className="font-light">{labels["header-menu-personal-area-signup-title"]}</p>
        <SignupButton />
      </div>
    </div>
  );
};
